import { DataBean } from "../DataBean";

export class WorkActivityTaskType extends DataBean {

  public async getWorkActivityTaskTypeCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityTaskTypeCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteWorkActivityTaskType(idworkactivitytasktype: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityTaskType_Number",
      [idworkactivitytasktype]
    );
  }

  public async updateWorkActivityTaskType(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityTaskType_updateWorkActivityTaskType_com.advantage.processflow.bean.WorkActivityTaskType",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivityTaskType",
        },
      ]
    );
  }
}
